import React from "react";
import Card from "react-bootstrap/Card";
import { AiOutlineCheck  } from "react-icons/ai";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            - Hello World, I am <span className="purple">Koustav Moitra </span>
            from <span className="purple"> West Bengal, India.</span>
            <br /><br />
            - I have 3+ years of experience in Software Development and Product Management, leveraging AI and automation to build smarter, more efficient products.
            <br /><br />
            -   My academic foundation includes a Master's (2022) and Bachelor's (2020), but my passion for technology extends far beyond the classroom.

            <br /><br />
            <br />
            But life isn't all about coding – when I'm not crafting software solutions, you'll find me:
          </p>
          <ul>
          <li className="about-activity">
          <AiOutlineCheck /> Strumming melodies on my <span className="wavy-underline">Guitar</span> 🎸
          </li>
          <li className="about-activity">
            <AiOutlineCheck /> Experimenting in the <span className="wavy-underline">kitchen</span> 🍳
          </li>
          <li className="about-activity">
            <AiOutlineCheck /> My <span className="wavy-underline">sketchbook</span> 🎨 becomes my console 
          </li>
          </ul>

        
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
